import { useEffect, useState } from 'react';
import queryHooks from '../../common/queryHooks/index.ts';
import M from 'materialize-css';
import mutationHooks from '../../common/mutationHooks/index.ts';

const OtherSettings = props => {
  const initValues = () => ({
    suspectMedEmailAddress: '',
  });

  const [values, setValues] = useState(initValues());

  const { data: user } = queryHooks.user.useReadOneById();
  const { mutate: updateOtherSettings } =
    mutationHooks.user.useUpdateOtherSettings();

  const onChange = ({ target: { id, value } }) =>
    setValues(p => ({ ...p, [id]: value }));

  const submit = e => {
    e.preventDefault();
    updateOtherSettings(values);
  };

  useEffect(() => {
    if (user?.suspectMedEmailAddress)
      setValues(prev => ({
        ...prev,
        suspectMedEmailAddress: user.suspectMedEmailAddress,
      }));
  }, [user]);

  useEffect(() => {
    M.updateTextFields();
  }, [values]);

  return (
    <div>
      <p>
        <b>Other Settings</b>
      </p>
      <div className="row">
        <div className="input-field col s12 m4">
          <input
            id="suspectMedEmailAddress"
            type={'text'}
            value={values.suspectMedEmailAddress}
            onChange={onChange}
          />
          <small className="grey-text">
            This email will be used to receive responses from the FDA when you
            report illegitimate medications. Please ensure you provide a valid
            email that is used frequently for these notifications.
          </small>
          <label htmlFor="suspectMedEmailAddress">
            Suspect Med Email Address
          </label>
        </div>
      </div>
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col s12 m4 l2">
          <a
            href="/"
            onClick={submit}
            className="btn btn-small blue white-text waves-effect waves-light col s12"
          >
            Submit
          </a>
        </div>
      </div>
    </div>
  );
};

export default OtherSettings;
